import { render } from "./Display.vue?vue&type=template&id=efa9935c&scoped=true"
import script from "./Display.vue?vue&type=script&lang=js"
export * from "./Display.vue?vue&type=script&lang=js"

import "./Display.vue?vue&type=style&index=0&id=efa9935c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa9935c"]])

export default __exports__